import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import languageList from '../../assets/language/language.json'
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import useWindowSize from "../../Hooks/useWindowSize";
import { 
  Container,
  LoginSectionWrapper,
  ChartTitle,
  Label,
  TopLabel,
  BottomText,
  HistoricalContainer,
  LeftTab,
  HistoricalLabel,
  RightTab,
  Underlying,
  Circle,
  SelectField,
  Year,
  ChartContainer,
  VerticalText,
  ChartWrapper,
  OptionField,
  OptionSpan,
  Divider,
  CustomOverlay,
  EmptyDataContainer,
  DummyTable
} from "./Chart.style";
import { DescriptionItem, DescriptionWrapper } from "./Innerpage.style";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AnnualReport = (props) => {

  const navigate = useNavigate();
  const {chartWidth, chartHeight, bottomtext, labels, dataSet,noDataText} = props;
  const windowSize = useWindowSize();
  const [searchParams] = useSearchParams();
  const language = searchParams.get("lang") || 'en';
  const { get } = useHttp();
  const [productName, setProductName] = useState(undefined)
  const [languages, setLanguage] = useState(null)

  useEffect(() => {
    if(languageList[language]){
      setLanguage(languageList[language])
    } else {
      setLanguage(languageList['en'])
    }

  }, [language])

const barThickness = windowSize.width < 600 ? 15 : windowSize.width < 900 ? 30 : 60;
const data = {
  labels,
  datasets: [
    {
      label: '',
      data: dataSet,
      backgroundColor: '#192d6e' || '#0096FF',
      barThickness: barThickness,
      barPercentage: 1,
    },
  ]
};

const getOptions = () => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        display: false
      },
      title: {
        display: false,
        text: '',
      },
      tooltip: {
        backgroundColor: "white",
        borderColor: "#192d6e",
        borderWidth: 1,
        titleColor: "#333",
        titleFont: { weight: "400", size: 13 },
        bodyColor: "#333",
        bodyFont: { weight: "bold", size: 14 },
        displayColors: true,
        boxPadding: 5,
        cornerRadius: 0, 
        padding: 8, 
        shadowOffsetX: 3,
        shadowOffsetY: 3,
        shadowBlur: 1,
        shadowColor: "rgba(0, 0, 0, 0.7)",
        callbacks: {
          label: function (tooltipItem) {
            let value = tooltipItem.raw; // Get the value
            return `${languages?.underlying}: ${value.toFixed(1)}%`; // Format with 1 decimal place and percentage
          },
        },
        usePointStyle: true,
        position: "average", 
        yAlign: function (tooltipItem) {
            return tooltipItem?.tooltipItems[0]?.raw < 0 ? "top" : "bottom"; // Adjust position based on value
        },
      },
      
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false
        }
      },
      y: {
        border:{
        //   dash: [3, 3], 
          display: false },
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            return `${value?.toFixed(1)} %`;
          },
          maxTicksLimit: 7,
        },
        grid: {
            drawBorder: false, // Hide default border
            color: (context) => (context.tick.value === 0 ? "black" : "rgba(0,0,0,0.1)"), // Make the 0 line black
            lineWidth: (context) => (context.tick.value === 0 ? 2 : 1), // Thicker line at y=0
          },
        beginAtZero: false,
      }
    },
    onClick: (evt, element) => {
      if(element.length > 0) {
          console.log(evt, element)
      }}
  };

  return options
}

  return (
    //  height={windowSize?.width < 1200 ? windowSize?.height : null}
    <Container>
      {!noDataText ? <LoginSectionWrapper>
          <ChartContainer>
            <VerticalText type={'year'}>
              {languages?.annual_return}
            </VerticalText>
            <Underlying>
                <Circle />
                <Label>{languages?.underlying}</Label>
            </Underlying>
            <ChartWrapper width={chartWidth || 'auto'} height={chartHeight}>
              <Bar options={getOptions()} data={data} height={chartHeight}/>
            </ChartWrapper>

          </ChartContainer>
        
          <Year>{languages?.years}</Year>
      {['QA', 'DEV'].includes(process.env.REACT_APP_ENV) ? <DummyTable>
      <table>
        <thead>
        <tr>
          {labels?.map((e=> <th>{e}</th>))}
        </tr>
        </thead>
        <tbody>
          <tr>
            {dataSet?.map((e=> <td>{e.toFixed(1) + '%'}</td>))}
          </tr>
        </tbody>
      </table>
      </DummyTable> : null}
      <BottomText bottomtext={!!bottomtext}>
        {bottomtext}
      </BottomText>
      </LoginSectionWrapper> : 
      
      <DescriptionWrapper margin={'32px'}>
      <DescriptionItem height={"100px"} className={'full-width font-bold'}>
        <span>{noDataText}</span>
      </DescriptionItem>
  </DescriptionWrapper>}
    </Container>
  );
};

export default AnnualReport;
